export default __webpack_public_path__ + "static/media/reward-3.2465d3e0.png";